<sirius-grid data-cy="product-header-commerce">
  <div class="sir-media">
    @if (mediaItems?.length) {
      <div>
        <commerce-product-image-slider
          data-cy="image-item"
          [mediaItems]="mediaItems || []"
          [imageData]="imageData">
        </commerce-product-image-slider>
      </div>
    }
  </div>

  <div class="sir-content">
    <div class="sir-brand">
      @if (children?.length) {
        <div class="logo-wrapper">
          @for (manufacturer of uniqueManufacturers; track manufacturer) {
            <a
              [siriusLink]="manufacturer.link">
              <img [alt]="manufacturer.name" class="sir-logo" [src]="manufacturer.logo"
              /></a>
            }
          </div>
        }
        <a [siriusLink]="partnerPageLink" data-cy="partner-page-link">
          @if (logo) {
            <img class="sir-logo" [src]="logo.url"
              />
          }</a>
        </div>
        <sirius-heading [text]="title" textStyleCategory="title" textStyleSize="l" data-cy="title"> </sirius-heading>
        <div class="sir-details">
          <div class="sir-text">
            @if (subTitle) {
              <sirius-heading [text]="subTitle" textStyleCategory="title" textStyleSize="xs" data-cy="subtitle">
              </sirius-heading>
            }
            @if (textHtml) {
              @if (textHtml) {
                <sirius-text-html
                  class="truncate-description"
                  [html]="textHtml"
                data-cy="text-html"></sirius-text-html>
              }
            }
            @if (longDescription || textHtml) {
              <a
                siriusButton
                [buttonText]="'button.readMore' | translate"
                [siriusLink]="getTabsLink()"
                buttonType="linkstyle"
                size="small"
                data-cy="read-more">
              </a>
            }
          </div>
          <div>
            @if (netWeight) {
              <div class="details-container sir-text-style-paragraph-m-default">
                <span class="sir-detail-label">Net Weight: </span>
                <span class="sir-detail-text" data-cy="details-net-weight"
                  >{{ netWeight.amount }} {{ netWeight.unit }}</span
                  >
                </div>
              }
              @if (!children || children.length === 0) {
                <div>
                  @if (sku) {
                    <div class="details-container sir-text-style-paragraph-m-default">
                      <span class="sir-detail-label">SKU#: </span>
                      <span class="sir-detail-text" data-cy="details-sku">{{ sku }}</span>
                    </div>
                  }
                </div>
              }
            </div>
            @if (children && children.length > 0) {
              <div>
                <p class="bundle-products sir-text-style-paragraph-l-bold">Bundle products</p>
                <div class="bundle-list">
                  @for (child of children; track child) {
                    <div class="bundle-item" data-cy="bundle-items">
                      @if (child) {
                        <commerce-bundle-item [config]="child"> </commerce-bundle-item>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="brand-website-container">
            @if (brand) {
              <div>
                <div class="brand-container">
                  <span class="brand-label sir-text-style-paragraph-m-default">{{ 'commerce.manufacturer' | translate }}:</span>
                  <span class="brand-name sir-text-style-paragraph-m-bold" data-cy="brand-name">{{ brand }}</span>
                </div>
              </div>
            }
            @if (externalLinks && externalLinks.length) {
              <div class="website-external-link">
                <a
                  class="website-external-link-item sir-text-style-paragraph-m-default"
                  [siriusLink]="handleExternalLinkClick(externalLinks[0])"
                  (linkSelect)="handleExternalLinkClick(externalLinks[0])"
                  data-cy="website-external-link-item"
                  title="Website">
                  {{ 'commerce.website' | translate }}
                </a>
                <sirius-icon
                  class="website-external-link-icon"
                name="arrow_square_out"></sirius-icon>
              </div>
            }
          </div>
          <div class="sir-buttons" data-cy="buttons-container">
            @if (storeExperienceType === storeExperienceTypeEnum.REQUEST_INFORMATION) {
              <a
                siriusButton
                [buttonText]="'commerce.requestInformation' | translate"
                [siriusLink]="getFormLink()"
                [buttonType]="'primary'"
                [size]="'large'"
                data-cy="request-information-button">
              </a>
            }
            @if (buttonSecondary) {
              <a
                siriusButton
                [buttonText]="buttonSecondary.link.title"
                [siriusLink]="buttonSecondary.link"
                [buttonType]="'secondary'"
                [size]="'large'"
                data-cy="secondary-button">
              </a>
            }
          </div>
        </div>
      </sirius-grid>
